/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./trigger.vue?vue&type=template&id=894ef138&scoped=true"
import script from "./trigger.vue?vue&type=script&lang=js"
export * from "./trigger.vue?vue&type=script&lang=js"
import style0 from "./trigger.vue?vue&type=style&index=0&id=894ef138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894ef138",
  null
  
)

export default component.exports